import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "adjustFontSize",
})
export class AdjustFontSizePipe implements PipeTransform {
  transform(value: string, adjust: number = -8): string {
    if (!value) return value;
    let size = parseInt(value, 10);
    if (isNaN(size)) return value; // Return the original value if it's not a number
    size += adjust; // Adjust the font size
    return `${size}px`;
  }
}
